'use client';

import React from 'react';
import { Toaster as ShadToaster } from './components/ui/toaster';

const Toaster = () => {
  return (
    <ShadToaster />
  );
}

export default Toaster
